import { apiService } from './apiService';

export const vehicleInspectionService = {
  async getAll() {
    return apiService.get('/vehicle-inspection-forms');
  },
  async getById(id: string | number) {
    return apiService.get(`/vehicle-inspection-forms/${id}`);
  },
  async create(data: any) {
    return apiService.post('/vehicle-inspection-forms', data);
  },
  async update(id: string | number, data: any) {
    return apiService.put(`/vehicle-inspection-forms/${id}`, data);
  },
  async delete(id: string | number) {
    return apiService.delete(`/vehicle-inspection-forms/${id}`);
  },
};
